import { createFileRoute } from '@tanstack/react-router'
import { useQuoteWorkspacePreload } from '@/features/quote-builder/api/preload'
import { CommunicationsInbox } from '@/features/quote-builder/communications/inbox'
import { PageHeader } from '@/features/quote-builder/ui/page'

type CommunicationsSearch = { thread?: string }

export const Route = createFileRoute('/_authenticated/communications')({
  staticData: { title: 'Communications' },
  validateSearch: (search: Record<string, unknown>): CommunicationsSearch => ({
    thread: typeof search.thread === 'string' ? search.thread : undefined,
  }),
  component: CommunicationsRoute,
})

function CommunicationsRoute() {
  useQuoteWorkspacePreload()
  return (
    <>
      <PageHeader title="Communications" />
      <CommunicationsInbox />
    </>
  )
}
